import apiService from "./apiService"

const locationApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchLocations: builder.query({
      query: () => ({ url: "location" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    updateLocation: builder.mutation({
      query: (location) => ({
        url: "location",
        method: "PUT",
        body: { location },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addLocation: builder.mutation({
      query: (location) => ({
        url: "location",
        method: "POST",
        body: location,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    deleteLocation: builder.mutation({
      query: (location) => ({
        url: "location",
        method: "DELETE",
        body: location,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default locationApiSlice

export const {
  useLazyFetchLocationsQuery,
  useUpdateLocationMutation,
  useAddLocationMutation,
  useDeleteLocationMutation,
} = locationApiSlice
